export default __webpack_public_path__ + "static/media/logo-espa.9d1b0811.svg";